// Lightweight time helpers used across ridership UI/API

// Converts a string like "h:mm AM/PM" to total minutes from midnight (0..1439 or more if hour > 23).
export function amPmToMinutes(time: string): number {
    const date = new Date(`1970-01-01 ${time}`);
    const h = date.getHours();
    const m = date.getMinutes();
    return h * 60 + m;
}

// Formats total minutes into "h:mm AM/PM"
export function minutesToAmPm(minutes: number): string {
    const date = new Date(1970, 0, 1, 0, minutes);
    const h24 = date.getHours();
    const mi = date.getMinutes();

    const mer = h24 >= 12 ? 'PM' : 'AM';
    let h12 = h24 % 12;
    if (h12 === 0) h12 = 12;

    const mm = mi.toString().padStart(2, '0');
    return `${h12}:${mm} ${mer}`;
}

export function to24Hour(time?: string): string {
    // Example: "01:30 PM" or "1:05 am"
    if (time == null) return '';
    const date = new Date(`1970-01-01 ${time}`);
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
}
